module.exports = __webpack_public_path__ + "media/close-overlay.7338aa51.ogg";